import { gql } from "@apollo/client";

const JOURNAL_FIELDS = `
  id
  authorId
  type
  dueDate
  status
  state
  assigneeId
  agendaJobId
  domain
  ref {
    id
    collection
  }
  data
  createdAt
  updatedAt
`;

export const GET_JOURNALS = gql`
  query GetJournals($input: JournalsInput!) {
    journals(input: $input) {
      total
      journals {
        ${JOURNAL_FIELDS}
      }
    }
  }
`;
